var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EmptyStateEntry',{attrs:{"title":_vm.$t('approvals.empty'),"text":_vm.$t('approvals.empty-description'),"image-src":"/images/empty-approval.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }